import { Screenfield } from './Screenfield';
export class cols {
  fieldName: string;
  value: string;
  screenfld: Screenfield;
}
